import { render, staticRenderFns } from "./LciCard.vue?vue&type=template&id=7c77f52c&scoped=true&"
import script from "./LciCard.vue?vue&type=script&lang=js&"
export * from "./LciCard.vue?vue&type=script&lang=js&"
import style0 from "./LciCard.vue?vue&type=style&index=0&id=7c77f52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c77f52c",
  null
  
)

export default component.exports